import {
  revalidateRelatedInputs,
  scrollToDanger,
  setupFormValidation
} from '@/utility/functions';

window.addEventListener('vueloaded', () => {

  let $checkout = document.getElementById('checkout');

  if($checkout) {
    setupFormValidation($checkout, function(e) {
      const $submit = $checkout.querySelector('[type="submit"]');

      $submit.setAttribute('disabled', true);
      $submit.classList.add('bg-gray-400', 'hover:bg-gray-400', 'cursor-not-allowed');

      const activeInputs = (form) => [...form.elements].filter(input => !input.disabled && input.type !== 'hidden');

      if(!window.validator.validate(activeInputs($checkout))) {
        e.preventDefault();

        scrollToDanger();

        $submit.classList.remove('bg-gray-400', 'hover:bg-gray-400', 'cursor-not-allowed');

        $submit.removeAttribute('disabled');
        return false;
      }
    });

    // detect IE11
    if(!(!!window.MSInputMethodContext && !!document.documentMode)) {
      const $ship_new = document.querySelectorAll('[name="ship_new"]');

      for(var i = 0; i < $ship_new.length; i++) {
        $ship_new[i].addEventListener('change', () => {
          revalidateRelatedInputs($ship_new);
        });
      }
    }
  }

});
